import { render, staticRenderFns } from "./Bhp.vue?vue&type=template&id=462f33d8&"
import script from "./Bhp.vue?vue&type=script&lang=js&"
export * from "./Bhp.vue?vue&type=script&lang=js&"
import style0 from "./Bhp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports